import { httpClient } from "../http/httpClient";

export type GetCommissionParams = {
  type: "CREFAZ" | "SALVCAR";
  value?: number;
};
export type GetCommissionResponse = {
  commission: number;
  range: {
    from: number;
    to: number;
  };
};

export const getCommission = async (params: GetCommissionParams) => {
  const { data } = await httpClient
    .get<GetCommissionResponse>(`/transaction/commission`, {
      params,
    })
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
